import { apiConstant } from './constant/api-constant';

const COMMENT_WRITE_PATHS: readonly string[] = [
    apiConstant.saveSOAComment,
    apiConstant.editSOAComment,
    apiConstant.deleteSOACommentById,
    apiConstant.resolveSOAComment,
    apiConstant.saveECBComment,
    apiConstant.editECBComment,
    apiConstant.deleteECBCommentById,
    apiConstant.resolveECBComment,
];

/**
 * Whether `url` is one of the SoA or ECB comment write calls. The query
 * string is ignored, so the resolve calls match with their parameters.
 */
export function isCommentWriteUrl(url: string | null | undefined): boolean {
    if (!url) return false;
    const path = url.split('?')[0];
    return COMMENT_WRITE_PATHS.some((writePath) => path.endsWith(writePath));
}
